function generateRandomString(size, includeSpecial = true) {
  const letters = "abcdefghijklmnopqrstuvwxyz0123456789";
  const symbols = "!@#$%^&*()_+~`|}{[]:;?><,./-="
  
  const charPool = includeSpecial ? letters + symbols : letters;
  let result = "";

  for (let i = 0; i < size; i++) {
    const randomIndex = Math.floor(Math.random() * charPool.length);
    result += charPool.charAt(randomIndex);
  }

  return result;
}


export default class CallToAction {
    constructor({ el }) {
        this.duration = 0.8
        this.distance = 30
        this.el = el

        const timeline = new gsap.timeline({
            paused: true,
         })

        this.label = this.el.querySelector(".label")
        

        this.split = new SplitText(this.label, {
            type: "words, chars",
            wordsClass: "flex-word",
            charsClass: "flex-char"
        });


        this.split.words.forEach(splitWord => {
            splitWord.querySelectorAll(".flex-char").forEach((char, i) => {
                char.dataset.index = i
            })
        })
        
        const shuffle = () => {
            this.split.words.forEach(splitWord => {
                const shuffled = gsap.utils.shuffle([...splitWord.querySelectorAll(".flex-char")]);
                shuffled.forEach(box => splitWord.appendChild(box));
            })
        }
        
        const reOrder = () => {
            this.split.words.forEach(splitWord => {
                const shuffled = [...splitWord.querySelectorAll(".flex-char")].sort((a, b) => a.dataset.index - b.dataset.index)
                shuffled.forEach(box => splitWord.appendChild(box));
            })
        }


        const tracker = {
            lastStep: -1,
            step: 0
        }
        timeline.to(tracker, {
            duration: 0.628,
            snap: "step",
            ease: "power2.inOut",
            step: 10,
            onUpdate: () => {
                if (tracker.step !== tracker.lastStep) {
                    shuffle()
                    tracker.lastStep = tracker.step
                }
            },
            onComplete: () => {
                reOrder()
            }
        }, "a")
        
        this.animateArrow(timeline)


        const parentElement = this.el.parentElement
        const animatedElement = parentElement instanceof HTMLAnchorElement ? parentElement : this.el

        if (parentElement) {
            const title = parentElement.querySelector(".post-title strong")


            this.titleSplit = new SplitText(title, {
                type: "words, chars",
                wordsClass: "flex-word",
                charsClass: "flex-char"
            });


            this.titleSplit.words.forEach(splitWord => {
                splitWord.querySelectorAll(".flex-char").forEach((char, i) => {
                    char.dataset.index = i
                })
            })
            
            const shuffle = (splitWord) => {
                // this.titleSplit.words.forEach(splitWord => {
                    const shuffled = gsap.utils.shuffle([...splitWord.querySelectorAll(".flex-char")]);
                    shuffled.forEach(box => splitWord.appendChild(box));
                // })
            }
            
            const reOrder = (splitWord) => {
                // this.titleSplit.words.forEach(splitWord => {
                    const shuffled = [...splitWord.querySelectorAll(".flex-char")].sort((a, b) => a.dataset.index - b.dataset.index)
                    shuffled.forEach(box => splitWord.appendChild(box));
                // })
            }


            this.titleSplit.words.forEach((splitWord, i) => {
                const tracker = {
                    lastStep: -1,
                    step: 0
                }

                timeline.to(tracker, {
                    duration: 0.5,
                    snap: "step",
                    ease: "power2.inOut",
                    step: 10,
                    onUpdate: () => {
                        if (tracker.step !== tracker.lastStep) {
                            shuffle(splitWord)
                            tracker.lastStep = tracker.step
                        }
                    },
                    onComplete: () => {
                        reOrder(splitWord)
                    }
                }, `a+=${i * 0.05}`)
            })

            // timeline.to(tracker, {
            //     duration: 0.628,
            //     snap: "step",
            //     ease: "power2.inOut",
            //     step: 10,
            //     onUpdate: () => {
            //         if (tracker.step !== tracker.lastStep) {
            //             shuffle()
            //             tracker.lastStep = tracker.step
            //         }
            //     },
            //     onComplete: () => {
            //         reOrder()
            //     }
            // }, "a")
        
        }
        
        animatedElement.addEventListener("mouseenter", () => {
            if (!timeline.isActive()) {
                timeline.play(0)
            }
        })
    }

    animateArrow(timeline) {
        const duration = 0.3
        const { distance } = this

        const defaultArrow = this.el.querySelector(".default-arrow")
        const midArrow = this.el.querySelector(".mid-arrow")
        gsap.set(this.el.querySelector("svg"), { perspective: 1000 });
        gsap.set(this.el.querySelector("g"), { perspective: 1000 });
        gsap
            .set(midArrow, {
                rotationX: 90,
                transformOrigin: "50% 50%"
            }, 'a')

        timeline
            .to(defaultArrow, {
                x: distance,
                duration: duration,
                ease: "quint.in",
            }, 'a')
            .to(midArrow, {
                x: distance,
                duration: duration * 2,
                ease: "quint.inOut",
            }, 'a')
            .set(defaultArrow, {
                x: -distance,
            }, `a+=${duration}`)
            .to(midArrow, {
                scaleY: 0,
                force3D: true,
                duration: duration * 0.2,
                yoyo: true,
                repeat: 1,
            }, `a+=${duration * .75}`)
            .to(defaultArrow, {
                x: 0,
                ease: "quint.out",
                duration: duration
            }, `a+=${duration}`)

    }

    dispose() {
    }
}